export default __webpack_public_path__ + "static/media/projectCodes.85895b19.svg";